module.exports = __webpack_public_path__ + "img/odins-logo-big.ef0cb680.png";